export default class Constants {
  private  static TAX_RATE = 20;

  static get taxRateMultiplier(): number {
    return 1 + Constants.TAX_RATE / 100;
  }
}
